<template>
    <div class="row mx-2 my-3 pricelist-settings">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>User Role Settings</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 10em">User Roles</th>
                        <template v-for="(item, idx) in allModules" :key="idx">
                            <th style="font-size: 14px; font-weight: 60;">
                                {{ item.name }}
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="role in allUserRoles" :key="role.id">
                        <td>{{ role.name }}</td>
                        <template v-for="(mod, idx) in role.modules" :key="idx">
                            <td class="text-center">
                                <input
                                    class="form-check-input cursor-pointer text-lg"
                                    type="checkbox"
                                    v-model="mod.checkPermission"
                                    :checked="mod.checkPermission"
                                    :disabled="checkDisabled(mod, role)"
                                />
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
            <div class="row">
                <div class="col-sm-12">
                    <button
                        @click="updateUserRoleSettings"
                        type="button"
                        class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
                    >
                        Update User Role Settings
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
    props: [],
    emits: [],
    components: {
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });
        let allUserRoles = computed(function () {
            return store.getters["setting/allUserRoles"];
        });
        let allModules = computed(function () {
            return store.getters["setting/allModules"];
        });

        function getAllUserRoles() {
            store.dispatch("setting/getAllUserRoles");
        }
        function getAllModules() {
            store.dispatch("setting/getAllModules");
        }
        function updateUserRoleModules(request) {
            store.dispatch("setting/updateUserRoleModules", request);
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            allUserRoles,
            allModules,
            getAllUserRoles,
            getAllModules,
            updateUserRoleModules
        };
    },
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    mounted() {
        this.populateData()
    },
    methods: {
        populateData() {
            this.getAllModules()
            this.getAllUserRoles()
        },
        updateUserRoleSettings() {
            console.log(this.allUserRoles)

            this.updateUserRoleModules({
                user_role_modules: this.allUserRoles
            })
        },
        checkDisabled(mod, role) {
            // console.log(mod,role)
        }
        
    },
};
</script>
